import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import serviceImg from "./Firefly_Gemini Flash (1).png";

function Services() {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 200);

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const services = [
    {
      title: "Photography & Videography",
      desc: "Professional shoots including architectural, portrait, product photography, and high-end field videography.",
      align: "left",
      path: "photography",
      className: "media",
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="4" />
          <rect x="3" y="3" width="18" height="18" rx="2" />
        </svg>
      ),
    },
    {
      title: "Real Estate Photo & Video Editing",
      desc: "Premium real estate post-production, multi-exposure blending, walkthroughs, and cinematic video editing.",
      align: "right",
      path: "photo-video-editing",
      className: "realestate",
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="4" width="16" height="16" />
        </svg>
      ),
    },
    {
      title: "Graphic Design (Marketing & Advertising Design)",
      desc: "Creative corporate branding layouts, high-impact marketing assets, and dynamic motion graphic animations.",
      align: "left",
      path: "graphic-design-real-estate",
      className: "graphic",
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="4" width="16" height="16" />
          <line x1="4" y1="10" x2="20" y2="10" />
          <line x1="10" y1="4" x2="10" y2="20" />
        </svg>
      ),
    },
  ];

  const handleClick = (path) => {
    navigate(`/services/${path}`);
    window.scrollTo(0, 0);
  };

  return (
    <div
      className="services-main-container"
      style={{
        ...styles.container,
        opacity: loaded ? 1 : 0,
        transform: loaded ? "translateY(0px)" : "translateY(30px)",
      }}
    >
      {/* LEFT CONTENT */}
      <div style={styles.left} className="responsive-left-pane">
        <h1 style={styles.heading} className="responsive-main-heading">
          Crafting Visual Excellence
        </h1>

        <p style={styles.subText} className="responsive-subtext">
          From stunning photography to cinematic edits and creative design —
          we transform your ideas into powerful visual experiences.
        </p>

        <div style={styles.timeline} className="responsive-timeline">
          {services.map((item, i) => (
            <div
              key={i}
              onClick={() => handleClick(item.path)}
              className={`service-row ${item.className}`}
              style={{
                ...styles.row,
                flexDirection: isMobile
                  ? "column-reverse"
                  : item.align === "left"
                  ? "row"
                  : "row-reverse",
              }}
            >
              <div className="service-card" style={styles.card}>
                <h3 style={styles.title} className="responsive-card-title">{item.title}</h3>
                <p style={styles.desc} className="responsive-card-desc">{item.desc}</p>
              </div>

              <div className="service-icon" style={styles.icon}>
                {item.icon}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT IMAGE WITH SOFT FADE EDGE - AUTOMATICALLY ADJUSTS IN MOBILE/ANDROID/IPHONE */}
      <div style={styles.right} className="responsive-right-pane">
        <div style={styles.imageWrapper} className="responsive-img-wrapper">
          <img
            src={serviceImg}
            alt="service"
            style={styles.image}
          />
          <div style={styles.overlay} className="responsive-image-overlay"></div>
        </div>
      </div>

      {/* CSS HOVER EFFECTS & POWERFUL MULTI-DEVICE RESPONSIVE ALIGNMENTS */}
      <style>{`
        body {
          margin: 0;
          overflow-x: hidden;
        }

        .service-row {
          margin-bottom: 4px;
        }

        .service-row:hover .service-card {
          transform: translateY(-6px) scale(1.02);
        }

        .service-row:hover .service-icon {
          transform: scale(1.1);
        }

        .realestate:hover .service-card {
          background: linear-gradient(135deg, #22c55e, #16a34a);
          color: white !important;
          box-shadow: 0 15px 40px rgba(34,197,94,0.15);
        }
        .realestate:hover .service-card h3,
        .realestate:hover .service-card p {
          color: white !important;
        }

        .media:hover .service-card {
          background: linear-gradient(135deg, #3b82f6, #06b6d4);
          color: white !important;
          box-shadow: 0 15px 40px rgba(59,130,246,0.15);
        }
        .media:hover .service-card h3,
        .media:hover .service-card p {
          color: white !important;
        }

        .graphic:hover .service-card {
          background: linear-gradient(135deg, #ec4899, #f43f5e);
          color: white !important;
          box-shadow: 0 15px 40px rgba(236,72,153,0.15);
        }
        .graphic:hover .service-card h3,
        .graphic:hover .service-card p {
          color: white !important;
        }

        .service-card {
          transition: all 0.3s ease;
        }

        .service-icon {
          transition: all 0.3s ease;
        }

        /* 🖥️ DESKTOP & LARGE SYSTEM VIEWS */
        @media (min-width: 992px) {
          .services-main-container {
            padding: 0 40px !important;
          }
          .responsive-left-pane {
            padding: 40px 20px !important;
          }
        }

        /* 📱 MOBILE, ANDROID & IPHONE VIEWS (Perfect Alignment Fix) */
        @media (max-width: 991px) {
          .services-main-container {
            padding: 40px 20px !important;
            justify-content: center !important;
            min-height: auto !important;
          }
          .responsive-left-pane {
            flex: 1 1 100% !important;
            maxWidth: 100% !important;
            padding: 0px !important;
          }
          .responsive-main-heading {
            fontSize: 2rem !important;
            textAlign: center !important;
          }
          .responsive-subtext {
            maxWidth: 100% !important;
            textAlign: center !important;
            margin-bottom: 35px !important;
          }
          .service-row {
            flex-direction: column-reverse !important;
            gap: 16px !important;
            margin-bottom: 20px !important;
          }
          .service-card {
            text-align: center !important;
            padding: 20px 16px !important;
          }
          .service-icon {
            margin: 0 auto !important;
          }
          
          /* Show image below the content in mobile or smoothly hide it */
          .responsive-right-pane {
            display: none !important; /* Mobile-ல் டிசைன் கிளீனாக இருக்க இமேஜ் மறைக்கப்படும் */
          }
        }

        @media (max-width: 480px) {
          .responsive-main-heading {
            fontSize: 1.75rem !important;
          }
          .responsive-card-title {
            fontSize: 1.1rem !important;
          }
          .responsive-card-desc {
            fontSize: 0.8rem !important;
          }
          .responsive-timeline {
            gap: 10px !important;
          }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "100vh",
    background: "#ffffff",
    fontFamily: "sans-serif",
    transition: "all 0.6s ease",
  },

  left: {
    flex: "1 1 550px",
    maxWidth: "600px",
  },

  heading: {
    fontWeight: "900",
    marginBottom: "12px",
    color: "#facc15",
    textShadow: "0 0 8px rgba(250,204,21,0.5)",
  },

  subText: {
    color: "#6b7280",
    marginBottom: "28px",
    lineHeight: "1.5",
  },

  timeline: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    width: "100%",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    cursor: "pointer",
    width: "100%",
  },

  card: {
    background: "#f9fafb",
    padding: "14px 16px",
    borderRadius: "16px",
    width: "100%",
  },

  title: {
    fontWeight: "700",
    marginBottom: "6px",
    color: "#1f2937",
  },

  desc: {
    fontSize: "0.85rem",
    color: "#6b7280",
    lineHeight: "1.4",
  },

  icon: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    border: "1px solid #e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
    flexShrink: 0,
  },

  right: {
    display: "flex",
    flex: "1 1 450px",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "100vh",
    overflow: "hidden",
  },

  imageWrapper: {
    width: "100%",
    height: "80%",
    position: "relative",
    overflow: "hidden",
  },

  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to right, #ffffff 0%, rgba(255, 255, 255, 0.9) 15%, rgba(255, 255, 255, 0) 50%)",
    pointerEvents: "none",
  },
};

export default Services;